<template>
  <div>
    <el-tabs v-model="qdtab" style="margin-right: 40px;margin-left: 40px;">
      <el-tab-pane label="讲师上课核销记录" name="jshxrec">
        <el-row class="querypanel">
          <el-col :span="24">
            <el-form ref="form"  label-width="120px" label-position="left">
              <el-form-item label="上课日期">
                <el-date-picker
                  v-model="teacherskdate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <el-button  @click="query_teacher_skrec">查询讲师上课核销记录</el-button>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-table
            fit
            :data="data_teacher_skrec">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              prop="weekid"
              label="星期">
            </el-table-column>
            <el-table-column
              prop="weektime"
              label="时间段">
            </el-table-column>
            <el-table-column
              prop="name.String"
              width="180px"
              label="讲师名">
            </el-table-column>
            <el-table-column
              prop="ctitle.String"
              label="班级名">
            </el-table-column>
            <el-table-column
              prop="price"
              label="价格">
            </el-table-column>
            <el-table-column
              prop="addtime"
              label="确认时间">
            </el-table-column>
            <el-table-column
              label="操作"
              min-width="30px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="删除记录" placement="top-start">
                  <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="del_teacher_rec(scope.$index, data_teacher_skrec)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="讲师上课核销" name="jshx">
        <div class="querypanel">
          <el-form ref="form"  label-width="120px" label-position="left">
          <el-row>
            <el-col :span="12">
              <el-form-item label="上课时间">
                <el-select v-model="weekinfo" clearable placeholder="按上课日期查询" >
                  <el-option
                    v-for="item in weeklist"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-button  @click="query_day_teacher">查询当日上课讲师</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="确认上课日期">
                <el-date-picker
                  v-model="skrq"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-button  @click="pl_add">*批量确认记录</el-button>
            </el-col>
          </el-row>
          </el-form>
        </div>
        <el-row class="querypanel">
          <el-col :span="12">
            <el-form ref="form"  label-width="120px" label-position="left">
              <el-form-item label="讲师姓名">
                <el-input  v-model="ed_jsname" placeholder="请输入讲师姓名"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <div>
              <el-button style="margin-top: 10px; margin-left: 10px;" @click="query_teacher">查询讲师上课记录</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-table
            fit
            :data="data_teacher"
            @selection-change="teacher_sel">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              prop="weekid"
              label="星期">
            </el-table-column>
            <el-table-column
              prop="weektime.String"
              label="时间段">
            </el-table-column>
            <el-table-column
              prop="name.String"
              width="180px"
              label="讲师名">
            </el-table-column>
            <el-table-column
              prop="cname.String"
              label="班级名">
            </el-table-column>
            <el-table-column
              prop="ctitle.String"
              label="课程名称">
            </el-table-column>
            <el-table-column
              prop="price.String"
              label="价格">
            </el-table-column>
          </el-table>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="会员上课核销记录" name="xyhxrec">
        <el-row class="querypanel">
          <el-col :span="24">
            <el-form ref="form"  label-width="120px" label-position="left">
              <el-form-item label="上课日期">
                <el-date-picker
                  v-model="userskdate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <el-button  @click="query_user_skrec">查询当日上课核销记录</el-button>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-table
            fit
            :data="date_user_skrec">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              prop="weekid"
              label="星期">
            </el-table-column>
            <el-table-column
              prop="weektime.String"
              label="时间段">
            </el-table-column>
            <el-table-column
              prop="userphone"
              width="180px"
              label="会员联系方式">
            </el-table-column>
            <el-table-column
              prop="cname.String"
              label="班级名">
            </el-table-column>
            <el-table-column
              prop="addtime.String"
              label="确认时间">
            </el-table-column>
            <el-table-column
              label="操作"
              min-width="30px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="删除记录" placement="top-start">
                  <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="del_user_rec(scope.$index, date_user_skrec)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="学员上课核销" name="xyhx">
        <el-row class="querypanel">
          <el-col :span="12">
            <el-form ref="form"  label-width="120px" label-position="left">
              <el-form-item label="上课时间">
                <el-select v-model="weekinfo1" clearable placeholder="按上课日期查询" >
                  <el-option
                    v-for="item in weeklist"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-button  @click="query_day_users">查询当日上课学员</el-button>
            <el-button style="margin-left: 10px;" @click="pl_addusers">*批量确认</el-button>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-col :span="12">
            <el-form ref="form"  label-width="120px" label-position="left">
              <el-form-item label="会员姓名">
                <el-input  v-model="ed_hyname" placeholder="请输入用户姓名"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <div>
              <el-button style="margin-top: 10px; margin-left: 10px;" @click="query_user">查询会员上课记录</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row class="querypanel">
          <el-table
            fit
            :data="data_users"
            @selection-change="user_sel">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              prop="weekid"
              label="星期">
            </el-table-column>
            <el-table-column
              prop="weektime.String"
              label="时间段">
            </el-table-column>
            <el-table-column
              prop="userphone"
              width="180px"
              label="学员联系方式">
            </el-table-column>
            <el-table-column
              prop="cname.String"
              label="班级名">
            </el-table-column>
          </el-table>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'RecMana',
  data () {
    return {
      qdtab: 'jshx',
      ed_jsname: '',
      skrq: '',
      ed_jscontact: '',
      teacherskdate: '',
      userskdate: '',
      data_teacher_skrec: [],
      date_user_skrec: [],
      weeklist: [{
        value: '1',
        label: '星期一'
      }, {
        value: '2',
        label: '星期二'
      }, {
        value: '3',
        label: '星期三'
      }, {
        value: '4',
        label: '星期四'
      }, {
        value: '5',
        label: '星期五'
      }, {
        value: '6',
        label: '星期六'
      }, {
        value: '0',
        label: '星期日'
      }],
      weekinfo: '',
      weekinfo1: '',
      weekinfo2: '',
      weekinfo3: '',
      data_teacher: [],
      data_users: [],
      khid: '',
      teacherlist: [],
      sel_teacher2: [],
      sel_user2: [],
      ed_hyname: ''
    }
  },
  mounted () {
    that = this
    console.log('开始创建')
    console.log(that)
    this.skrq = new Date()
    var week = this.skrq.getDay()
    this.weekinfo = week.toString()
  },
  methods: {
    query_teacher_skrec () {
      var qstr = 'cusid =' + that.khid
      if (this.teacherskdate !== null && this.teacherskdate !== '') {
        qstr = qstr + " and addtime >= '" + this.teacherskdate[0] + "' and addtime<='" + this.teacherskdate[1] + "'"
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/gbto',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取讲师核销数据')
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_teacher_skrec = JSON.parse(res.data.data)
            console.log(that.data_teacher_skrec)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    del_teacher_rec (index, data) {
      var curselectdata = data[index]
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/dbto',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id.Int64)
            // 移除该条数据
            data.splice(dataindex, 1)
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    query_user_skrec () {
      var qstr = 'cusid =' + that.khid
      if (this.userskdate !== null && this.userskdate !== '') {
        qstr = qstr + " and addtime >= '" + this.userskdate[0] + "' and addtime<='" + this.userskdate[1] + "'"
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/gbuo',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取会员核销数据')
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.date_user_skrec = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    del_user_rec: function (index, data) {
      var curselectdata = data[index]
      console.log(curselectdata)
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/dbuo',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + curselectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var dataindex = data.findIndex(d => d.id.Int64 === curselectdata.id.Int64)
            // 移除该条数据
            data.splice(dataindex, 1)
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    query_teacher: function () {
      console.log('查询讲师')
      var qstr = 'cusid =' + that.khid
      if (that.ed_jsname !== null && that.ed_jsname !== '') {
        qstr = qstr + " and name like '%" + that.ed_jsname + "%' "
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/course/qbcs',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取讲师数据')
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_teacher = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    query_user: function () {
      console.log('查询讲师')
      var qstr = 'cusid =' + that.khid
      if (that.ed_hyname !== null && that.ed_hyname !== '') {
        qstr = qstr + " and name like '%" + that.ed_hyname + "%' "
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/class/qbcs',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功获取讲师数据')
            that.$message({
              type: 'success',
              message: '已查询结果'
            })
            that.data_users = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    query_day_teacher () {
      if (that.weekinfo !== '' && that.weekinfo !== null) {
        var wstr = ' weekid = ' + that.weekinfo
        that.$http({
          url: 'https://api.sqnetsoft.cn/course/qbcs',
          method: 'post',
          data: {
            whereinfo: {String: wstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              console.log(JSON.parse(res.data.data))
              that.data_teacher = JSON.parse(res.data.data)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        that.data_teacher = []
      }
    },
    query_day_users () {
      if (that.weekinfo1 !== '' && that.weekinfo1 !== null) {
        var wstr = ' weekid = ' + that.weekinfo1
        that.$http({
          url: 'https://api.sqnetsoft.cn/class/qbcs',
          method: 'post',
          data: {
            whereinfo: {String: wstr, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              console.log(JSON.parse(res.data.data))
              that.data_users = JSON.parse(res.data.data)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        that.data_users = []
      }
    },
    teacher_sel (rows) {
      that.sel_teacher2 = []
      if (rows) {
        rows.forEach(row => {
          that.sel_teacher2.push(row)
        })
      }
    },
    user_sel (rows) {
      that.sel_user2 = []
      if (rows) {
        rows.forEach(row => {
          that.sel_user2.push(row)
        })
      }
    },
    pl_add () {
      var attlist = []
      for (var index in this.sel_teacher2) {
        var subdata = this.sel_teacher2[index]
        var adata
        adata = {
          state: parseInt(1),
          teacherid: subdata.teacherid,
          classid: subdata.classid,
          plandate: getNowFormat(that.skrq),
          weekid: parseInt(subdata.weekid),
          weektime: subdata.weektime.String,
          courseid: subdata.courseid,
          price: subdata.price.String,
          addtime: getNowFormatDate(),
          cusid: parseInt(this.khid)
        }
        attlist.push(adata)
      }
      if (attlist.length > 0) {
        that.$http({
          url: 'https://api.sqnetsoft.cn/order/paaubto',
          method: 'post',
          data: attlist,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '添加完毕'
              })
            } else {
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    },
    pl_addusers () {
      var attlist = []
      for (var index in this.sel_user2) {
        var subdata = this.sel_user2[index]
        var adata
        adata = {
          state: parseInt(1),
          way: parseInt(0),
          userphone: subdata.userphone.toString(),
          classid: subdata.classid,
          plandate: subdata.plandate.String,
          weekid: parseInt(subdata.weekid),
          weektime: subdata.weektime.String,
          addtime: getNowFormatDate(),
          cusid: parseInt(this.khid)
        }
        attlist.push(adata)
      }
      console.log(attlist)
      if (attlist.length > 0) {
        that.$http({
          url: 'https://api.sqnetsoft.cn/order/paaubuo',
          method: 'post',
          data: attlist,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '添加完毕'
              })
            } else {
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
  },
  created: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    console.log(that)
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}

function getNowFormat (datestr) {
  var date = new Date(datestr)
  var seperator1 = '-'
  var month = date.getMonth() + 1
  var strDate = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  var hours = date.getHours()
  if (hours >= 0 && hours <= 9) {
    hours = '0' + hours
  }
  var minutes = date.getMinutes()
  if (minutes >= 0 && minutes <= 9) {
    minutes = '0' + minutes
  }
  var seconds = date.getSeconds()
  if (seconds >= 0 && seconds <= 9) {
    seconds = '0' + seconds
  }
  var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
  return currentdate
}

function getNowFormatDate () {
  var date = new Date()
  var seperator1 = '-'
  var seperator2 = ':'
  var month = date.getMonth() + 1
  var strDate = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  var hours = date.getHours()
  if (hours >= 0 && hours <= 9) {
    hours = '0' + hours
  }
  var minutes = date.getMinutes()
  if (minutes >= 0 && minutes <= 9) {
    minutes = '0' + minutes
  }
  var seconds = date.getSeconds()
  if (seconds >= 0 && seconds <= 9) {
    seconds = '0' + seconds
  }
  var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate + ' ' + hours + seperator2 + minutes + seperator2 + seconds
  return currentdate
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/course/RecMana.vue